import { useSelector } from "react-redux"
import { createAffiliationHooks } from "pages/School/CreateAffiliation"
import { createClassHooks } from "pages/School/CreateClass"
import { CreateGradeHooks } from "pages/School/CreateGrade"
import { testTakerHooks } from "pages/School/CreateTestTaker"
import { useCallback, useContext } from "react"
import { AbilityContext } from "components/Permissions/Can"
import { getAffiliationLabel } from "pages/School/Affiliations/hooks/getAffiliationLabel"
import { affiliationGroups } from "keys"
import { last } from "lodash"
import { HeaderContext } from "../HeaderContext"
import { useDispatch } from "react-redux"
import { FilterTestTakers } from ".."
import { useQuery, useQueryClient } from "@tanstack/react-query"
import { affiliationGroupNames } from "keys/affiliationGroups"
import qc from "keys/queryClient"

const usePulldowns = () => {
    const dispatch = useDispatch()
    const ability = useContext(AbilityContext)
    const queryClient = useQueryClient()

    const { testTakers } = useContext(HeaderContext)

    const { affiliations, groups } = useSelector(state => state.affiliation)
    const { grades, schoolClasses, learningGroups } = useSelector(state => state.testTaker)
    const { brokenDisplay } = useSelector(state => state.general)
    const { headerFilters } = useSelector(state => state.header)

    const isSuperuser = ability.can("manage", "super-user")

    const createGradeAlert = CreateGradeHooks.useAlert()
    const setClassAlert = createClassHooks.useAlert()
    const setTestTakerAlert = testTakerHooks.useAlert()
    const setAffiliationAlert = createAffiliationHooks.useAlert()

    const { data: cities } = useQuery({
        queryKey: [qc.cities],
        enabled: false,
    });

    const group = headerFilters?.group?.name || headerFilters?.affiliation?.group_name
    const isSchoolGroup = group == affiliationGroups.schools

    // const schoolClasses = schoolClasses.filter(schoolClass =>
    //     schoolClass.grade.id == grade?.id && schoolClass.affiliation == affiliation.
    // )

    const filterAffiliationGroups = groups?.filter(group => affiliationGroupNames.includes(group.name))

    const pulldowns =
        // memo(() =>
        [{
            id: 1,
            placeholder: "סוג מוסד",
            options: filterAffiliationGroups,
            name: "group",
            component: "autoComplete",
            width: 200,
            fullWidth: true,
            hide: groups?.length <= 1
        },
        {
            id: 2,
            placeholder: "עיר",
            options: cities,
            name: "city",
            component: "autoComplete",
            width: 200,
            labelKey: "label",
            showBlurred: !!brokenDisplay,
            fullWidth: true,
            hide: !isSuperuser
        },
        {
            id: 3,
            placeholder: "שם המוסד",
            options: affiliations,
            name: "affiliation",
            getTooltip: brokenDisplay ? null : (opt) => getAffiliationLabel(opt),
            component: "autoComplete",
            width: 220,
            showBlurred: !!brokenDisplay,
            fullWidth: true,
        },
        {
            id: 4,
            placeholder: "שכבה",
            name: "grade",
            component: "autoComplete",
            width: 130,
            options:
                // [
                // {
                //     createNew: true,
                //     feature: "create_grade",
                //     permissionHOC: "hidden",
                //     role: "create"
                // }
                // ].concat(
                grades
            // )
            ,
            // createNew: {
            //     label: "הוספת שכבה",
            //     action: () => createGradeAlert(true),

            // },
            fullWidth: true
        },
        {
            id: 5,
            placeholder: "כיתה",
            options:
                // isSuperuser ? [
                //     {
                //         createNew: true,
                //         feature: "create_t_class",
                //         permissionHOC: "hidden",
                //         role: "create"
                //     }
                // ].concat(schoolClasses) :
                schoolClasses,
            name: "school_class",
            component: "autoComplete",
            noOptionsText: headerFilters.grade ? "אין תוצאות" : "בחר שכבה",
            width: 130,
            // createNew: {
            //     label: "הוספת כיתה",
            //     action: () => setClassAlert(true),
            // },
            fullWidth: true
        },
        {
            id: 6,
            name: "test_taker",
            component: "custom",
            customComponent: FilterTestTakers,
            placeholder: "שם התלמיד",
            getTooltip: brokenDisplay ? null : (opt) => opt.school_class,
            brokenDisplay: brokenDisplay,
            showBlurred: !!brokenDisplay,
        }
            // {
            //     id: 5,
            //     placeholder: "שם התלמיד",
            //     options: testTakers.data,
            //     getTooltip: (opt) => opt.school_class,
            //     name: "test_taker",
            //     handleChange: handleChangePulldown,
            //     component: "autoComplete",
            //     width: 200,
            //     optionsLimit: 20,
            //     brokenDisplay: brokenDisplay,
            //     blurred: brokenDisplay && true,
            //     fullWidth: true,
            //     loading: testTakers.isLoading,
            // options: [
            //     {
            //         createNew: true,
            //         feature: "create_test_taker",
            //         permissionHOC: "hidden",
            //         role: "create"
            //     }
            // ].concat(testTakers),
            // createNew: {
            //     label: "הוספת תלמיד.ה",
            //     action: () => setTestTakerAlert(true),
            // },
            // }
        ]
    // , [])

    const learningGroupPulldowns = [
        // בחירת סוג לקוח
        pulldowns[0],
        // בחירת עיר
        pulldowns[1],
        // בחירת שם לקוח
        pulldowns[2],
        {
            name: "learning_group",
            placeholder: "שם הקבוצה",
            options: learningGroups,
            component: "autoComplete",
        },
        // בחירת תלמיד
        last(pulldowns),
    ]

    return (isSchoolGroup || !group) ? pulldowns : learningGroupPulldowns

}

export default usePulldowns